import { Hardware, SupportPurchase } from '../../api/api-generated';
import { truncateISOString } from '../../utils/dateTime';
import { SupportPurchaseFilter } from './supportPurchasesTypes';

export const supportPurchaseValidator = (item: any) => {
  if (!item.software && !item.softwareId) return false;
  if (!item.company && !item.companyId) return false;
  if (!item.supportStartDate) return false;
  if (!item.supportEndDate) return false;
  const hardwareNoNulls = item.hardware.filter(
    (h: Hardware | null) => h !== null
  );
  if (hardwareNoNulls.length < 1) return false;
  return true;
};

export const supportPurchaseMiddleware = (
  name: string,
  value: string,
  state: any,
  autoboxValue?: any,
  autoboxLabel?: string
) => {
  if (autoboxLabel === 'order') return { order: autoboxValue };
  if (autoboxLabel === 'software') return { software: autoboxValue };
  if (autoboxLabel === 'newHardware')
    return { hardware: [...state.hardware, null] };
  if (autoboxLabel === 'deleteHardware') {
    const index = Number(autoboxValue);
    return {
      hardware: state.hardware
        .slice(0, index)
        .concat(state.hardware.slice(index + 1)),
    };
  }
  if (autoboxLabel?.startsWith('hardware')) {
    const index = Number(autoboxLabel.slice(8));
    const hardwareArrayCopy = [...state.hardware];
    hardwareArrayCopy[index] = autoboxValue;
    return { hardware: hardwareArrayCopy };
  }
  if (name === 'supportStartDate') {
    if (state.supportEndDate && truncateISOString(state.supportEndDate) < value)
      return { supportStartDate: state.supportStartDate };
  }
  if (name === 'supportEndDate') {
    if (
      state.supportStartDate &&
      truncateISOString(state.supportStartDate) > value
    )
      return { supportEndDate: state.supportEndDate };
  }
  return {};
};

export const filterSupportPurchase = (
  item: SupportPurchase,
  filters: SupportPurchaseFilter | undefined
): boolean => {
  if (!filters) return true;
  if (filters.company && filters.company.id !== item.companyId) return false;
  if (filters.software && filters.software.id !== item.softwareId) return false;
  return true;
};
